import type { ReactNode } from 'react';

/** Panel del prototipo: .panel > .head (título, descripción, insignia) + contenido. */
export function Panel({
  title,
  description,
  badge,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  badge?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="panel">
      <div className="head">
        <div>
          <h3>{title}</h3>
          {description ? <p>{description}</p> : null}
        </div>
        {badge}
      </div>
      {children}
    </div>
  );
}

export type BadgeTone = 'green' | 'blue' | 'red' | 'amber' | undefined;

export function Badge({ tone, children }: { tone?: BadgeTone; children: ReactNode }) {
  return <span className={tone ? `badge ${tone}` : 'badge'}>{children}</span>;
}
